import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Language, SessionKey } from "util/Constants";

import englishCommon from "./en/common.json";
import chineseCommon from "./zh/common.json";
import malayCommon from "./ms/common.json";

/// <summary>
/// Author: KurisuCodes
/// </summary>
const _resources = {};
_resources[Language.ENGLISH] = { common: englishCommon };
_resources[Language.CHINESE] = { common: chineseCommon };
_resources[Language.MALAY] = { common: malayCommon };

i18n
    .use(initReactI18next)
    .init({
        defaultNS: "common",
        debug: false,
        resources: _resources,
        lng: localStorage.getItem(SessionKey.LANGUAGE) || Language.ENGLISH,
        fallbackLng: [Language.ENGLISH],
        keySeparator: false,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });


export default i18n;